import SelaAccordionStatus from './component.jsx'
export default SelaAccordionStatus
